import React from 'react';
import {Layout} from '../layout';
import {Spacer} from '../spacer';
import {Text} from '../text';
import {DatePickerTriggerStyleMap} from './styles';
import {DatePickerKind, DatePickerSize} from './types';

type Props = {
  kind: DatePickerKind;
  size: DatePickerSize;
  title: string;
  caption?: string;
};

export const DatePickerTrigger: React.FC<Props> = ({
  size,
  kind,
  caption,
  title,
}) => {
  return (
    <Layout
      vertical
      justify="center"
      borderRadius={'4'}
      height={DatePickerTriggerStyleMap[kind][size].height}
      paddingHorizontal={DatePickerTriggerStyleMap[kind][size].padding}
      backgroundColor={DatePickerTriggerStyleMap[kind][size].backgroundColor}>
      {caption && (
        <>
          <Text variant="inline_12_emphasis">{caption}</Text>
          <Spacer height="6" />
        </>
      )}
      <Text
        textColor={DatePickerTriggerStyleMap[kind][size].textColor}
        variant="inline_14_default">
        {title}
      </Text>
    </Layout>
  );
};
